export const TransactionEventStatus = {
  Pending: "pending",
  Processing: "processing",
  Settled: "settled",
  Returned: "returned",
  Canceled: "canceled",
} as const;
export type TransactionEventStatus =
  (typeof TransactionEventStatus)[keyof typeof TransactionEventStatus];
